import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ICampaign } from '../../../../models/campaign';
import { isHtmlEmpty } from '../../../../utils/html.utils';

@Component({
  selector: 'edit-campaign-content',
  templateUrl: './edit-campaign-content.component.html',
  styleUrls: ['./edit-campaign-content.component.scss']
})
export class EditCampaignContentComponent implements OnChanges {
  @Input() campaign: ICampaign;
  @Input() completions: any[] = [];
  @Output() campaignChange = new EventEmitter<ICampaign>();

  public draft: ICampaign;
  public isHtmlEmpty = isHtmlEmpty;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.campaign && this.campaign) {
      this.draft = { ...this.campaign };
    }
  }

  public emit() {
    this.campaignChange.emit({ ...this.draft });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/email/campaigns/edit-campaign-content/edit-campaign-content.component.ts